import { FC, memo } from 'react';
import map from 'lodash/map';
import Steps from 'antd/lib/steps';

import { headerSteps, IStepComponentProps } from 'components/ImportCsv/constants';

const { Step } = Steps;

const Header: FC<IStepComponentProps> = ({ step }) =>
  <>
    <h2>Import products from a CSV file</h2>
    <Steps current={step} labelPlacement="vertical" className="m-t-25 m-b-25">
      {map(headerSteps, (title: string) => <Step key={title} title={title} />)}
    </Steps>
  </>;

export default memo(Header);
